<app-lp-template>
    <div class="px-3 pb-3 pt-2">
        <h4 class="text-center">{{message}}</h4>
    </div>
</app-lp-template>